import React from "react";
import "./tech.css";
import next from "../../assets/nextjs.png";

const Tech = () => {
  return (
    <section id="technologies">
      <div className="title">
        <h2 className="content-title">
          Full stack frameworks I have working knowledge of
        </h2>
      </div>

      <div className="content-wrap">
        {/* Top Row */}
        <div className="top">
          <div className="logoLanguages">
            <h2 className="techName">HTML</h2>
            <img src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/html5/html5-original.svg" />
          </div>
          <div className="logoLanguages">
            <h2 className="techName">JavaScript</h2>
            <img src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/javascript/javascript-original.svg" />
          </div>
          <div className="logoLanguages">
            <h2 className="techName">CSS</h2>
            <img src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/css3/css3-original.svg" />
          </div>
          <div className="logoLanguages">
            <h2 className="techName">React</h2>
            <img src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/react/react-original.svg" />
          </div>
          <div className="logoLanguages">
            <h2 className="techName">Next.js</h2>
            <img src={next} alt="Next JS Logo" />
          </div>
          <div className="logoLanguages">
            <h2 className="techName">GraphQL</h2>
            <img src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/graphql/graphql-plain.svg" />
          </div>
        </div>

        {/* Bottom Row */}
        <div className="bottom">
          <div className="logoLanguages">
            <h2 className="techName">MongoDB</h2>
            <img src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/mongodb/mongodb-original.svg" />
          </div>
          <div className="logoLanguages">
            <h2 className="techName">Git</h2>
            <img src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/git/git-original.svg" />
          </div>
          <div className="logoLanguages">
            <h2 className="techName">npm</h2>
            <img src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/npm/npm-original-wordmark.svg" />
          </div>
          <div className="logoLanguages">
            <h2 className="techName">Heroku</h2>
            <img src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/heroku/heroku-original.svg" />
          </div>
          <div className="logoLanguages">
            <h2 className="techName">BootStrap</h2>
            <img src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/bootstrap/bootstrap-original.svg" />
          </div>
        </div>
        {/* 3rd row */}
        <div className="top">
          <div className="logoLanguages">
            <h2 className="techName">Python</h2>

            <img src="https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/python/python-original.svg" />
          </div>
          <div className="logoLanguages">
            <h2 className="techName">MariaDB</h2>

            <img src="https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/mariadb/mariadb-original.svg" />
          </div>
          <div className="logoLanguages">
            <h2 className="techName">Chroma</h2>
            <img src="https://cdn.jsdelivr.net/gh/homarr-labs/dashboard-icons/png/chroma.png" />
          </div>
          <div className="logoLanguages">
            <h2 className="techName">Langchain</h2>
            <img src="https://cdn.jsdelivr.net/npm/@lobehub/icons-static-png@latest/light/langchain-color.png" />
          </div>
          <div className="logoLanguages">
            <h2 className="techName">OpenAI Integrations</h2>
            <img
              src="https://cdn.jsdelivr.net/gh/homarr-labs/dashboard-icons/png/openai-light.png"
              alt="Next JS Logo"
            />
          </div>
          <div className="logoLanguages">
            <h2 className="techName">Hugging Face</h2>
            <img src="https://cdn.jsdelivr.net/gh/homarr-labs/dashboard-icons/png/hugging-face.png" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Tech;
